export const getRejectReasonsForStep = (
  rejectReasons: Record<string, any> | null | undefined,
  stepId: number,
): Record<string, string> => {
  if (!rejectReasons) return {}

  const mapping: Record<string, string> = {}

  if (stepId === 1 && rejectReasons.deal_overview) {
    const overview = rejectReasons.deal_overview
    if (overview.project_name) mapping.projectName = overview.project_name
    if (overview.sales_type) mapping.salesType = overview.sales_type
    if (overview.sales_type_detail)
      mapping.salesTypeDetail = overview.sales_type_detail
    if (overview.category_tags) mapping.category = overview.category_tags
    if (overview.jurisdiction) mapping.jurisdiction = overview.jurisdiction
    if (overview.jurisdiction_other)
      mapping.jurisdictionOther = overview.jurisdiction_other
    if (overview.logo_url) mapping.logo = overview.logo_url
    if (overview.urls) {
      if (typeof overview.urls === 'string') mapping.urls = overview.urls
      else if (typeof overview.urls === 'object') {
        if (overview.urls.website)
          mapping['url-website'] = overview.urls.website
        if (overview.urls.x) mapping['url-x'] = overview.urls.x
        if (overview.urls.discord)
          mapping['url-discord'] = overview.urls.discord
      }
    }
    if (overview.pitch_deck) mapping.pitchDeck = overview.pitch_deck
    if (overview.research_report_url)
      mapping.researchReport = overview.research_report_url
    if (overview.cap_table) {
      if (Array.isArray(overview.cap_table)) {
        overview.cap_table.forEach((msg: any, index: number) => {
          if (msg) mapping[`capTable-${index}`] = String(msg)
        })
      } else {
        mapping.capTable = overview.cap_table
      }
    }
    if (overview.whitelist_csv) mapping.whitelistCsv = overview.whitelist_csv
  }

  if (stepId === 2) {
    const summary = rejectReasons.project_summary
    if (summary) {
      if (summary.project_overview)
        mapping.description = summary.project_overview
      if (summary.traction) mapping.summaryTraction = summary.traction
      if (summary.token_utility_economics)
        mapping.summaryTokenUtilityEconomics = summary.token_utility_economics
      if (summary.roadmap) mapping.summaryRoadmap = summary.roadmap
      if (summary.competitive_landscape)
        mapping.summaryCompetitiveLandscape = summary.competitive_landscape
      if (summary.risk_evaluation)
        mapping.summaryRiskEvaluation = summary.risk_evaluation
      if (summary.project_features)
        mapping.summaryProjectFeatures = summary.project_features
      if (summary.investment_thesis)
        mapping.summaryInvestmentThesis = summary.investment_thesis
      if (summary.team) {
        if (Array.isArray(summary.team)) {
          summary.team.forEach((msg: any, index: number) => {
            if (msg) mapping[`team-${index}`] = String(msg)
          })
        } else {
          mapping.teamMembers = summary.team
        }
      }
    }
  }

  if (stepId === 3) {
    const terms = rejectReasons.deal_terms || rejectReasons.detail
    if (terms) {
      if (terms.pricing_method) mapping.pricingMethod = terms.pricing_method
      if (terms.fdv) mapping.fdv = terms.fdv
      if (terms.token_price) mapping.tokenPrice = terms.token_price
      if (terms.token_supply) mapping.tokenSupply = terms.token_supply
      if (terms.max_raise) mapping.maxRaise = terms.max_raise
      if (terms.min_raise_threshold)
        mapping.minimumRaiseThreshold = terms.min_raise_threshold
      if (terms.min_investment_per_user)
        mapping.minimumInvestmentPerUser = terms.min_investment_per_user

      if (terms.cliff) mapping.cliff = terms.cliff
      if (terms.linear_vesting) mapping.linearVesting = terms.linear_vesting
      if (terms.tge_release) mapping.tgeRelease = terms.tge_release

      if (terms.flexible_schedules) {
        if (Array.isArray(terms.flexible_schedules)) {
          terms.flexible_schedules.forEach((pool: any, index: number) => {
            if (!pool) return
            if (typeof pool === 'string') {
              mapping[`flexible-${index}`] = pool
            } else if (typeof pool === 'object') {
              if (pool.name) mapping[`flexible-${index}-name`] = pool.name
              if (pool.fdv) mapping[`flexible-${index}-fdv`] = pool.fdv
              if (pool.tge_release)
                mapping[`flexible-${index}-tgeRelease`] = pool.tge_release
              if (pool.cliff) mapping[`flexible-${index}-cliff`] = pool.cliff
              if (pool.linear_vesting)
                mapping[`flexible-${index}-linearVesting`] = pool.linear_vesting
            }
          })
        } else {
          mapping.flexibleSchedules = terms.flexible_schedules
        }
      }

      if (terms.project_token_address)
        mapping.projectTokenAddress = terms.project_token_address
      if (terms.project_token_symbol)
        mapping.projectTokenSymbol = terms.project_token_symbol
      if (terms.project_token_name)
        mapping.projectTokenName = terms.project_token_name
      if (terms.project_token_decimals)
        mapping.projectTokenDecimals = terms.project_token_decimals

      if (terms.distribution_chain_id)
        mapping.distributionChain = terms.distribution_chain_id
    }

    const referrals = rejectReasons.referrals
    if (referrals) {
      if (referrals.general_discount)
        mapping.referralGeneralDiscount = referrals.general_discount
      if (referrals.general_kickback)
        mapping.referralGeneralKickback = referrals.general_kickback
      if (referrals.custom_csv) mapping.referralCustomCsv = referrals.custom_csv
      if (referrals.t1_discount)
        mapping.referralDiscountT1 = referrals.t1_discount
      if (referrals.t2_discount)
        mapping.referralDiscountT2 = referrals.t2_discount
      if (referrals.t3_discount)
        mapping.referralDiscountT3 = referrals.t3_discount
      if (referrals.t1_kickback)
        mapping.referralKickbackT1 = referrals.t1_kickback
      if (referrals.t2_kickback)
        mapping.referralKickbackT2 = referrals.t2_kickback
      if (referrals.t3_kickback)
        mapping.referralKickbackT3 = referrals.t3_kickback
    }
  }

  if (stepId === 4 && rejectReasons.fund_allocation) {
    const funds = rejectReasons.fund_allocation
    if (funds.project_receiving_wallet)
      mapping.projectWallet = funds.project_receiving_wallet
    if (funds.has_asset_manager)
      mapping.hasAssetManager = funds.has_asset_manager
    if (funds.asset_manager_wallet)
      mapping.assetManagerWallet = funds.asset_manager_wallet
    if (funds.lockdrop_curator_wallet)
      mapping.lockdropCuratorWallet = funds.lockdrop_curator_wallet
    if (funds.lockdrop_performance_fees_type)
      mapping.lockdropPerformanceFeesType = funds.lockdrop_performance_fees_type
    if (funds.lockdrop_performance_fees_stablecoin)
      mapping.lockdropPerformanceFeesStablecoin =
        funds.lockdrop_performance_fees_stablecoin
    if (funds.lockdrop_performance_fees_token)
      mapping.lockdropPerformanceFeesToken =
        funds.lockdrop_performance_fees_token
    if (funds.lockdrop_management_fees_type)
      mapping.lockdropManagementFeesType = funds.lockdrop_management_fees_type
    if (funds.lockdrop_management_fees_stablecoin)
      mapping.lockdropManagementFeesStablecoin =
        funds.lockdrop_management_fees_stablecoin
    if (funds.lockdrop_management_fees_token)
      mapping.lockdropManagementFeesToken = funds.lockdrop_management_fees_token
    if (funds.curator_commitment_amount)
      mapping.curatorCommitmentAmount = funds.curator_commitment_amount
    if (funds.curator_proofs) mapping.transactionLink = funds.curator_proofs
    if (funds.curator_fee_bips)
      mapping.flatCommissionRate = funds.curator_fee_bips
    if (funds.curator_wallet)
      mapping.curatorCommissionWallet = funds.curator_wallet

    if (funds.token_fees) {
      if (funds.token_fees.stablecoin_percent_bips)
        mapping.stablecoinFeePercent = funds.token_fees.stablecoin_percent_bips
      if (funds.token_fees.token_percent_bips)
        mapping.tokenFeePercent = funds.token_fees.token_percent_bips
    }
  }

  if (stepId === 5 && rejectReasons.sale_timeline) {
    const timelines = rejectReasons.sale_timeline
    if (typeof timelines === 'object') {
      if (timelines.purchase_start_date)
        mapping.purchaseStartDate = timelines.purchase_start_date
      if (timelines.purchase_end_date)
        mapping.purchaseEndDate = timelines.purchase_end_date
      if (timelines.mint_start_date)
        mapping.mintStartDate = timelines.mint_start_date
      if (timelines.tge_target_date)
        mapping.tgeTargetDate = timelines.tge_target_date
      if (timelines.vesting_start_date)
        mapping.vestingStartDate = timelines.vesting_start_date
    }
  }

  if (stepId === 6) {
    const accessory = rejectReasons.accessory_project_services
    const royalty =
      rejectReasons.trading_royalty || rejectReasons.metadata?.nftMetadata

    if (accessory?.secondary_market_enabled)
      mapping.secondaryMarketEnabled = accessory.secondary_market_enabled
    if (royalty?.royalty_bips) mapping.royaltyPercentage = royalty.royalty_bips

    const split = royalty?.royalty_split
    if (split) {
      if (split.project_bips)
        mapping['royaltySplit.project'] = split.project_bips
      if (split.curator_bips)
        mapping['royaltySplit.curator'] = split.curator_bips
    }

    if (royalty?.nft_transferable) {
      mapping.nftTransferability = royalty.nft_transferable
    }
  }

  if (stepId === 7) {
    if (rejectReasons.marketingGuidelinesAgreementAccepted)
      mapping.marketingGuidelinesAgreementAccepted =
        rejectReasons.marketingGuidelinesAgreementAccepted
  }

  if (
    stepId === 8 &&
    rejectReasons.accessory_project_services?.accessory_services
  ) {
    mapping.accessoryServices =
      rejectReasons.accessory_project_services.accessory_services
  }

  return mapping
}

export const getFieldLabel = (fieldId: string): string => {
  const labels: Record<string, string> = {
    projectName: 'Project Name',
    salesType: 'Deal Type',
    salesTypeDetail: 'Sales Type Detail',
    category: 'Category Tags',
    jurisdiction: 'Jurisdiction',
    jurisdictionOther: 'Other Jurisdiction',
    logo: 'Logo',
    'url-website': 'Official Site URL',
    'url-x': 'X (Twitter) URL',
    'url-discord': 'Discord URL',
    pitchDeck: 'Pitch Deck',
    researchReport: 'Research Materials',
    capTable: 'Cap Table',
    whitelistCsv: 'Whitelist CSV',

    description: 'Project Narrative',
    summaryTraction: 'Traction',
    summaryTokenUtilityEconomics: 'Token Utility & Economics',
    summaryRoadmap: 'Roadmap',
    summaryCompetitiveLandscape: 'Competitive Landscape',
    summaryRiskEvaluation: 'Risk Evaluation',
    summaryProjectFeatures: 'Project Features',
    summaryInvestmentThesis: 'Investment Thesis',
    teamMembers: 'Team Members',

    pricingMethod: 'Pricing Method',
    fdv: 'FDV',
    tokenPrice: 'Token Price',
    tokenSupply: 'Total Token Supply',
    maxRaise: 'Max Raise',
    minimumRaiseThreshold: 'Minimum Raise',
    minimumInvestmentPerUser: 'Minimum Investment Per User',
    cliff: 'Cliff Period',
    linearVesting: 'Linear Vesting',
    tgeRelease: 'TGE Release',
    flexibleSchedules: 'Flexible Pricing Options',
    projectTokenAddress: 'Project Token Address',
    projectTokenSymbol: 'Token Symbol',
    projectTokenName: 'Token Name',
    projectTokenDecimals: 'Token Decimals',
    distributionChain: 'Distribution Chain',
    referralGeneralDiscount: 'General Referral Discount',
    referralGeneralKickback: 'General Referral Kickback',
    referralCustomCsv: 'Custom Referral CSV',
    referralDiscountT1: 'Tier 1 Referral Discount',
    referralDiscountT2: 'Tier 2 Referral Discount',
    referralDiscountT3: 'Tier 3 Referral Discount',
    referralKickbackT1: 'Tier 1 Referral Kickback',
    referralKickbackT2: 'Tier 2 Referral Kickback',
    referralKickbackT3: 'Tier 3 Referral Kickback',

    projectWallet: 'Project Receiving Wallet',
    hasAssetManager: 'Asset Manager',
    assetManagerWallet: 'Asset Manager Wallet',
    lockdropCuratorWallet: 'Lockdrop Curator Wallet',
    lockdropPerformanceFeesType: 'Performance Fees Type',
    lockdropPerformanceFeesStablecoin: 'Performance Fees (Stablecoins)',
    lockdropPerformanceFeesToken: 'Performance Fees (Tokens)',
    lockdropManagementFeesType: 'Management Fees Type',
    lockdropManagementFeesStablecoin: 'Management Fees (Stablecoins)',
    lockdropManagementFeesToken: 'Management Fees (Tokens)',
    curatorCommitmentAmount: 'Curator Commitment Amount',
    transactionLink: 'Transaction Link',
    flatCommissionRate: 'Flat Commission Rate',
    curatorCommissionWallet: 'Curator Commission Wallet',
    stablecoinFeePercent: 'Stablecoin Fee Percent',
    tokenFeePercent: 'Token Fee Percent',

    purchaseStartDate: 'Purchase Start Date',
    purchaseEndDate: 'Purchase End Date',
    mintStartDate: 'Mint Start Date',
    tgeTargetDate: 'TGE Target Date',
    vestingStartDate: 'Vesting Start Date',

    secondaryMarketEnabled: 'Secondary Market Trading',
    royaltyPercentage: 'Royalty Percentage',
    'royaltySplit.project': 'Project Royalty Split',
    'royaltySplit.curator': 'Curator Royalty Split',
    nftTransferability: 'NFT Transferability',

    marketingGuidelinesAgreementAccepted: 'Legal Agreements',

    accessoryServices: 'Accessory Services',
  }

  if (fieldId.startsWith('flexible-')) {
    const parts = fieldId.split('-')
    const index = Number.parseInt(parts[1]) + 1
    const field = parts[2]
    const poolPrefix = `Pool ${index}`
    if (!field) return poolPrefix
    const fieldLabels: Record<string, string> = {
      name: 'Name',
      fdv: 'FDV',
      tgeRelease: 'TGE Release',
      cliff: 'Cliff Period',
      linearVesting: 'Linear Vesting',
    }
    return `${poolPrefix} ${fieldLabels[field] || field}`
  }

  if (fieldId.startsWith('team-')) {
    const parts = fieldId.split('-')
    const index = Number.parseInt(parts[1]) + 1
    return `Team Member ${index}`
  }

  if (fieldId.startsWith('capTable-')) {
    const parts = fieldId.split('-')
    const index = Number.parseInt(parts[1]) + 1
    return `Cap Table Investor ${index}`
  }

  return labels[fieldId] || fieldId
}
